import { createSlice } from '@reduxjs/toolkit'

export const CustomerBootstrapDataSlice = createSlice({
  name: 'customer_bootstrap_data',

  initialState: {
    value: {}
  },
  reducers: {
    updateCustomerBootstrapData: (state, action) => {
        if(action?.payload?.type){
            return { ...state,
                value:{
                  ...state.value,[action?.payload?.type]: action?.payload?.value
                }              
            }
        } else {
            state.value = action?.payload
        }     
    }
  }
})

export const { updateCustomerBootstrapData } = CustomerBootstrapDataSlice.actions

export default CustomerBootstrapDataSlice.reducer